import React from "react";
import Index from "../views/dashboard/index";
// import { Switch, Route } from 'react-router-dom'
// admin - DELETED
// import Default from "../layouts/dashboard/default"; // DELETED
import DefaultForCalendar from "../layouts/dashboard/defaultForCalendar";

// myPages
import RegisAdminForm from "../components/FormComponents/registerAdminPage1";
import LicenseManagment from "../components/LicenceManagmentCompo/licenseManagmentPage";
import BillManagement from "../components/BillManagementCompo/BillManagmentPage";
import SettingsManagement from "../components/SettingsCompo/settingsManagement";
import PartnerTable from "../components/PartnersManagementCompo/partnerManagement";
import RoleTable from "../components/RoleManagementCompo/roleManagementPage";
import UsersTable from "../components/UserManagementCompo/userManagementTable";
import DepartmentTable from "../components/DepartmentManagementCompo/departmentManagementPage";
import ServicesTable from "../components/ServicesManagementCompo/servicesManagementPage";
import DualSidebarNav from "../components/partials/dashboard/SidebarStyle/dual-sidebar";
import DualAdminSideBarNav from "../components/partials/dashboard/SidebarStyle/dual-admin-sidebar";

import { Navigate } from "react-router-dom";
import { getLocalStorageData } from "../../src/services/axiosComponent";
import { PrivateRoute, CheckUserTypeRoute } from "../services/protectedRoutes";

// Import Route Designer Page
import RouteDesignerPage from "../components/OrganisationUsersModules/TransportManagementCompo/RouteDesignerPage";

export const DefaultRouter = [
  // Standalone Route Designer (Full Screen, No Sidebar)
  {
    path: "/transport/route-designer",
    element: (
      <PrivateRoute>
        <CheckUserTypeRoute>
          <RouteDesignerPage />
        </CheckUserTypeRoute>
      </PrivateRoute>
    ),
  },
  {
    path: "/",
    element: (
      <PrivateRoute>
        <CheckUserTypeRoute>
          <DualAdminSideBarNav />
        </CheckUserTypeRoute>
      </PrivateRoute>
    ),
    children: [
      {
        path: "dashboard",
        element: <Index />,
      },
      {
        path: "dashboard/license",
        element: <LicenseManagment />,
      },
      {
        path: "dashboard/bill",
        element: <BillManagement />,
      },
      {
        path: "dashboard/settings",
        element: <SettingsManagement />,
      },
      {
        path: "dashboard/partners",
        element: <PartnerTable />,
      },
      {
        path: "dashboard/roles",
        element: <RoleTable />,
      },
      {
        path: "dashboard/users",
        element: <UsersTable />,
      },
      {
        path: "dashboard/departments",
        element: <DepartmentTable />,
      },
      {
        path: "dashboard/services",
        element: <ServicesTable />,
      },
      // set your basic routes here!

      // {
      //   path: "dashboard/special-pages/billing",
      //   element: <Billing />,
      // },
      // {
      //   path: "dashboard/special-pages/calender",
      //   element: <Calender />,
      // },
      // {
      //   path: "dashboard/special-pages/kanban",
      //   element: <Kanban />,
      // },
      // {
      //   path: "dashboard/special-pages/pricing",
      //   element: <Pricing />,
      // },
      // {
      //   path: "dashboard/special-pages/timeline",
      //   element: <Timeline />,
      // },
      // {
      //   path: "dashboard/special-pages/rtl-support",
      //   element: <RtlSupport />,
      // },
      // {
      //   path: "dashboard/app/user-profile",
      //   element: <UserProfile />,
      // },
      // {
      //   path: "dashboard/app/user-add",
      //   element: <UserAdd />,
      // },
      // {
      //   path: "dashboard/app/user-list",
      //   element: <UserList />,
      // },
      // {
      //   path: "dashboard/admin/admin",
      //   element: <Admin />,
      // },
      // // Widget
      // {
      //   path: "dashboard/widget/widgetbasic",
      //   element: <Widgetbasic />,
      // },
      // {
      //   path: "dashboard/widget/widgetchart",
      //   element: <Widgetchart />,
      // },
      // {
      //   path: "dashboard/widget/widgetcard",
      //   element: <Widgetcard />,
      // },
      // // Map
      // {
      //   path: "dashboard/map/google",
      //   element: <Google />,
      // },
      // {
      //   path: "dashboard/map/vector",
      //   element: <Vector />,
      // },
      // // Form
      // {
      //   path: "dashboard/form/form-element",
      //   element: <FormElement />,
      // },
      // {
      //   path: "dashboard/form/form-wizard",
      //   element: <FormWizard />,
      // },
      // {
      //   path: "dashboard/form/form-validation",
      //   element: <FormValidation />,
      // },
      // // Table
      // {
      //   path: "dashboard/table/bootstrap-table",
      //   element: <BootstrapTable />,
      // },
      // {
      //   path: "dashboard/table/table-data",
      //   element: <TableData />,
      // },
      // // Icon
      // {
      //   path: "dashboard/icon/solid",
      //   element: <Solid />,
      // },
      // {
      //   path: "dashboard/icon/outline",
      //   element: <Outline />,
      // },
      // {
      //   path: "dashboard/icon/dual-tone",
      //   element: <DualTone />,
      // },
    ],
  },
];
